/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCampaignFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfCampaignFromDiscriminatorValue, serializeCampaign, serializeCampaignInput, type Campaign, type CampaignInput, type ErrorResponse, type InternalErrorResponse, type PagedResultOfCampaign } from '../../models/index.js';
// @ts-ignore
import { type WithCampaignItemRequestBuilder, WithCampaignItemRequestBuilderNavigationMetadata, WithCampaignItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { SimulateRequestBuilderRequestsMetadata, type SimulateRequestBuilder } from './simulate/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/campaigns
 */
export interface CampaignsRequestBuilder extends BaseRequestBuilder<CampaignsRequestBuilder> {
    /**
     * The simulate property
     */
    get simulate(): SimulateRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.campaigns.item collection
     * @param campaignId Unique identifier of the item
     * @returns {WithCampaignItemRequestBuilder}
     */
     byCampaignId(campaignId: string) : WithCampaignItemRequestBuilder;
    /**
     * The organization's campaigns, newest first, a page at a time, with their promotions embedded. Filter on active to see only live or only retired campaigns. The redemption count on each campaign is server-managed and moves only at checkout.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfCampaign>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<CampaignsRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfCampaign | undefined>;
    /**
     * Creates an active campaign with its promotions. A campaign is the container and the audience (window, customers, channels, market codes, order types — every restriction optional, all AND-ed) and the trigger: Automatic applies to every cart in the audience, Code needs one of the campaign's discount codes. Each promotion carries optional thresholds, a scope of categories (with descendants) and SKUs, and exactly one benefit: an order discount (dollar or percentage, optionally tiered), a line discount, a free gift SKU, or free shipping. Values follow the rep discount rules: positive, two decimal places, percentages at most 100.
     * @param body A campaign as the Web Admin builder sends it: the audience, the trigger, the cap and theembedded promotions. Counters (redemptionCount) are never part of the input — they areserver-managed (D11).
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Campaign>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CampaignInput, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Campaign | undefined>;
    /**
     * The organization's campaigns, newest first, a page at a time, with their promotions embedded. Filter on active to see only live or only retired campaigns. The redemption count on each campaign is server-managed and moves only at checkout.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<CampaignsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Creates an active campaign with its promotions. A campaign is the container and the audience (window, customers, channels, market codes, order types — every restriction optional, all AND-ed) and the trigger: Automatic applies to every cart in the audience, Code needs one of the campaign's discount codes. Each promotion carries optional thresholds, a scope of categories (with descendants) and SKUs, and exactly one benefit: an order discount (dollar or percentage, optionally tiered), a line discount, a free gift SKU, or free shipping. Values follow the rep discount rules: positive, two decimal places, percentages at most 100.
     * @param body A campaign as the Web Admin builder sends it: the audience, the trigger, the cap and theembedded promotions. Counters (redemptionCount) are never part of the input — they areserver-managed (D11).
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CampaignInput, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * The organization's campaigns, newest first, a page at a time, with their promotions embedded. Filter on active to see only live or only retired campaigns. The redemption count on each campaign is server-managed and moves only at checkout.
 */
export interface CampaignsRequestBuilderGetQueryParameters {
    /**
     * Only active (true) or only inactive (false) campaigns; omit for all.
     */
    active?: boolean;
    /**
     * Which page to return, counting from 1.
     */
    pageNumber?: number;
    /**
     * How many campaigns per page.
     */
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const CampaignsRequestBuilderUriTemplate = "{+baseurl}/api/campaigns?pageNumber={pageNumber}&pageSize={pageSize}{&active*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CampaignsRequestBuilderNavigationMetadata: Record<Exclude<keyof CampaignsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCampaignId: {
        requestsMetadata: WithCampaignItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithCampaignItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["campaignId"],
    },
    simulate: {
        requestsMetadata: SimulateRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CampaignsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CampaignsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfCampaignFromDiscriminatorValue,
    },
    post: {
        uriTemplate: CampaignsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCampaignFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCampaignInput,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
